import React from 'react'
import Select from 'react-select';

import * as SizeSelectorStyles from "./sizeSelector.module.css";
import { LanguageContext } from '../../utils/LanguageContext';

export const defaultSizes = [
  { value: 'XSmall', label: 'XS', color: '#ff6d00', isDisabled: false },
  { value: 'Small', label: 'S', color: '#ff6d00', isDisabled: false },
  { value: 'Medium', label: 'M', color: '#ff6d00', isDisabled: false },
  { value: 'Large', label: 'L', color: '#ff6d00', isDisabled: false },
  { value: 'XLarge', label: 'XL', color: '#ff6d00', isDisabled: true },
]

// ? https://react-select.com/styles#overriding-the-theme
const customTheme = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    neutral20: "var(--grey)",
    neutral50: "var(--grey-dark)",
    primary: "var(--orange)",
    primary75: "var(--orange80)",
    primary50: "var(--orange60)",
    primary25: "var(--orange20)",
  }
})

const getSizesOptions = sizes => {
  if (!Array.isArray(sizes)) {
    sizes = sizes.split('/')
  }
  return defaultSizes.map(defaultSize => ({
    ...defaultSize,
    isDisabled: !sizes.find(size => size.toUpperCase() === defaultSize.label.toUpperCase())
  }))
}

const SizeSelector = ({ sizes = defaultSizes, onSizeSelect }) => (
  <LanguageContext.Consumer>
    {({ language }) => (
      <Select
        className={SizeSelectorStyles.selector}
        defaultValue={null}
        theme={customTheme}
        onChange={onSizeSelect}
        isClearable={true}
        isSearchable={false}
        placeholder={language === 'Spanish' ? 'Selecciona una talla' : 'Select size'}
        aria-label="Size select"
        name="size"
        options={getSizesOptions(sizes)}
      />
    )}
  </LanguageContext.Consumer>
)

export default SizeSelector

// ? Previous selector with multiple fixed boxes
/* const SizeSelector = ({ sizes = defaultSizes, onSizeSelect, selectedSize }) => (
  <div className={SizeSelectorStyles.container}>
    {sizes.map(size => (
      <div key={size.value} className={SizeSelectorStyles.sizeOptionWrapper}>
        <label className={
          [
            SizeSelectorStyles.sizeOptionLabel,
            selectedSize.value === size.value ? SizeSelectorStyles.checked : ""
          ].join(" ")}>
          <input
            type="radio"
            value={size.value}
            checked={selectedSize.value === size.value}
            onChange={() => onSizeSelect(size)}
            className={SizeSelectorStyles.sizeOptionInput}/>
          {size.label}
        </label>
      </div>
    ))}
  </div>
) */